var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgValuacion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 19.79V21.875C0 23.5986 4.38732 25 9.79495 25C15.2026 25 19.5899 23.5986 19.5899 21.875V19.79C17.483 21.2109 13.6313 21.875 9.79495 21.875C5.95859 21.875 2.10693 21.2109 0 19.79ZM16.3249 6.25C21.7325 6.25 26.1199 4.84863 26.1199 3.125C26.1199 1.40137 21.7325 0 16.3249 0C10.9173 0 6.52997 1.40137 6.52997 3.125C6.52997 4.84863 10.9173 6.25 16.3249 6.25ZM0 14.668V17.1875C0 18.9111 4.38732 20.3125 9.79495 20.3125C15.2026 20.3125 19.5899 18.9111 19.5899 17.1875V14.668C17.483 16.3281 13.6262 17.1875 9.79495 17.1875C5.9637 17.1875 2.10693 16.3281 0 14.668ZM21.2224 15.2051C24.1456 14.6631 26.1199 13.6572 26.1199 12.5V10.415C24.9363 11.2158 23.1967 11.7627 21.2224 12.0996V15.2051ZM9.79495 7.8125C4.38732 7.8125 0 9.56055 0 11.7188C0 13.877 4.38732 15.625 9.79495 15.625C15.2026 15.625 19.5899 13.877 19.5899 11.7188C19.5899 9.56055 15.2026 7.8125 9.79495 7.8125ZM20.9826 10.5615C24.0435 10.0342 26.1199 8.99902 26.1199 7.8125V5.72754C24.3088 6.95312 21.1969 7.61231 17.9217 7.76856C19.4266 8.4668 20.5337 9.4043 20.9826 10.5615Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValuacion);
export default __webpack_public_path__ + "static/media/valuacion.6761ed1c9d346f5cde3b2d03cc832ed6.svg";
export { ForwardRef as ReactComponent };